import React, { useState } from 'react';
import { fGetPlural } from 'utils/functions';

function LimitedTimeDealTimer({ startDate, endDate, timerLabel }) {
  const [daysText, setDaysText] = useState(0);
  const [hoursText, setHoursText] = useState(0);
  const [minutesText, setMinutesText] = useState(0);
  const [secondsText, setSecondsText] = useState(0);
  const [percentageText, setPercentageText] = useState(0);

  const countDownStartDate = new Date(startDate).getTime();
  const countDownEndDate = new Date(endDate).getTime();
  var countDownDiff = countDownEndDate - countDownStartDate;

  const timeInterval = setInterval(() => {
    const now = new Date().getTime();
    const distance = countDownEndDate - now;

    if (distance < 0) {
      clearInterval(timeInterval);
    }
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    setDaysText(days);
    setHoursText(hours);
    setMinutesText(minutes);
    setSecondsText(seconds);
    var timerPercentage = 0;
    const startDiff = now - countDownStartDate;
    timerPercentage = Math.floor((startDiff / countDownDiff) * 100);

    setPercentageText(timerPercentage);
  }, 1000);

  const now = new Date().getTime();
  if (countDownEndDate - now < 0) {
    clearInterval(timeInterval);
  }

  return countDownStartDate &&
    countDownEndDate &&
    countDownEndDate - now > 0 ? (
    <div className="countdown-container">
      <div className="countdown-text">
        <span>{timerLabel}</span>
        <span className="countdown-time">
          {daysText > 0 && (
            <span>
              {fGetPlural({
                number: daysText,
                plural: 'days',
                singular: 'day',
              })}
            </span>
          )}
          {hoursText > 0 && (
            <span>
              {fGetPlural({
                number: hoursText,
                plural: 'hours',
                singular: 'hour',
              })}
            </span>
          )}
          {minutesText > 0 && (
            <span>
              {fGetPlural({
                number: minutesText,
                plural: 'minutes',
                singular: 'minute',
              })}
            </span>
          )}
          {secondsText > 0 && (
            <span>
              {fGetPlural({
                number: secondsText,
                plural: 'seconds',
                singular: 'second',
              })}
            </span>
          )}
        </span>
      </div>
      <div className="countdown-bar-container">
        <div className="countdown-bar"></div>
      </div>
      <style jsx>
        {`
          .countdown-container {
            width: 100%;
          }
          .countdown-text {
            font-size: 13px;
            color: #818184;
            font-family: 'Roboto-Medium';
            display: ${daysText > 0 ? 'grid' : 'flex'};
            gap: 4px;
          }

          .countdown-time {
            color: #ce1c1c;
            display: flex;
            gap: 4px;
          }
          .countdown-bar-container {
            background: #d9d9d9;
            border-radius: 8px;
            height: 7px;
            overflow: hidden;
            margin-top: 4px;
          }
          .countdown-bar {
            background: #ce1c1c;
            height: 100%;
            width: ${percentageText}%;
          }
        `}
      </style>
    </div>
  ) : null;
}

export default LimitedTimeDealTimer;
